"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactRouterDom = require("react-router-dom");
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _LoginForm = _interopRequireDefault(require("../LoginForm"));
var _AuthRedirect;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((_AuthRedirect = /*#__PURE__*/function (_React$Component) {
  _inherits(AuthRedirect, _React$Component);
  function AuthRedirect() {
    _classCallCheck(this, AuthRedirect);
    return _callSuper(this, AuthRedirect, arguments);
  }
  _createClass(AuthRedirect, [{
    key: "render",
    value: function render() {
      /*
      -if anon
      redirect to login page or render login form
      -if registered
      if url matches a route
          need to check which route is role homepage and send 'em there
      else if no homepage redirect to /
      else (no match)
          render 404
      */
      var content = 'Redirecting...';
      if (!Fortress.auth()) {
        var actionText = 'Log In';
        if ((0, _get2["default"])(AppDefs, 'app.login.labels.title', null)) {
          actionText = (0, _get2["default"])(AppDefs, 'app.login.labels.title');
        } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText', null)) {
          actionText = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText');
        }
        content = /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            maxWidth: '400px',
            margin: '0 auto'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, actionText)), /*#__PURE__*/_react["default"].createElement(_LoginForm["default"], {
          defaultRedirectUrl: Boilerplate.url(this.props.location.pathname),
          title: ""
        }));
      }
      if (Fortress.auth()) {
        var nav = (0, _cccisdLaravelAppdefs.findNav)(AppDefs.navs, AppDefs.routes);
        var homepageRoute = Fortress.settings.role === 'questprojectadmin' ? {
          url: '/quest'
        } : (0, _find2["default"])(AppDefs.routes, function (r) {
          return r.handle === nav.homepage;
        });

        // if this is not a pass-through display default 404 page
        if (this.props.isComponentOnly) {
          content = /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.NotFound, null);
        } else if (homepageRoute) {
          content = /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: homepageRoute.url
            }
          });
        } else {
          content = /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: '/'
            }
          });
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, content);
    }
  }]);
  return AuthRedirect;
}(_react["default"].Component), _defineProperty(_AuthRedirect, "propTypes", {
  location: _propTypes["default"].object,
  match: _propTypes["default"].object,
  history: _propTypes["default"].object,
  /**
   * This components also handles showing the 404 page.
   * We pass this prop when we know we want to show the 404 page
   */
  isComponentOnly: _propTypes["default"].bool
}), _AuthRedirect));